import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var ChartDateIntervalSelectorMapperService = /** @class */ (function () {
    function ChartDateIntervalSelectorMapperService(translateService) {
        this.translateService = translateService;
    }
    ChartDateIntervalSelectorMapperService.prototype.toLineChartFormat = function (data, interval) {
        var series = [];
        if (!data || !interval) {
            return;
        }
        if (interval === 'DAY') {
            series.push.apply(series, tslib_1.__spread(this.getDaysInterval(data.items)));
        }
        if (interval === 'WEEK') {
            series.push.apply(series, tslib_1.__spread(this.getWeeksInterval(data.items)));
        }
        if (interval === 'MONTH') {
            series.push.apply(series, tslib_1.__spread(this.getMonthsInterval(data.items)));
        }
        return {
            name: this.translateService.instant('CHART_DATE_INTERVAL_SELECTOR.TITLE'),
            series: series
        };
    };
    ChartDateIntervalSelectorMapperService.prototype.getDaysInterval = function (data) {
        var _this = this;
        return data.map(function (item) {
            return {
                name: moment(item.date).format('DD/MM'),
                formattedName: _this.capitalize(moment(item.date).locale('pt-br').format('dddd')),
                initialDate: item.date,
                finalDate: item.date,
                value: item.totalCount,
                totalCount: item.totalCount,
                item: item
            };
        });
    };
    ChartDateIntervalSelectorMapperService.prototype.getWeeksInterval = function (data) {
        var groupedWeeks = this.groupByWeeks(data);
        return this.getWeeksAverage(groupedWeeks);
    };
    ChartDateIntervalSelectorMapperService.prototype.groupByWeeks = function (data) {
        var weeks = [];
        var week = [];
        data.forEach(function (item, index) {
            week.push(item);
            if (index === data.length - 1 || moment(item.date).isoWeek() !== moment(data[index + 1].date).isoWeek()) {
                weeks.push(week);
                week = [];
            }
        });
        return weeks;
    };
    ChartDateIntervalSelectorMapperService.prototype.getMonthsInterval = function (data) {
        var groupedMonths = this.groupByMonths(data);
        return this.getMonthsAverage(groupedMonths);
    };
    ChartDateIntervalSelectorMapperService.prototype.getWeeksAverage = function (data) {
        return data.map(function (week) {
            var filteredWeek = week.filter(function (item) { return item.totalCount !== 0; });
            var sum = filteredWeek.reduce(function (acc, curr) { return acc + curr.value; }, 0);
            var totalCount = week.reduce(function (acc, curr) { return acc + curr.totalCount; }, 0);
            var average = sum / (filteredWeek.length || 1);
            return {
                name: moment(week[0].date).format('DD/MM') + " - " + moment(week[week.length - 1].date).format('DD/MM'),
                formattedName: moment(week[0].date).format('DD/MM') + " - " + moment(week[week.length - 1].date).format('DD/MM'),
                initialDate: week[0].date,
                finalDate: week[week.length - 1].date,
                value: average,
                totalCount: totalCount
            };
        });
    };
    ChartDateIntervalSelectorMapperService.prototype.groupByMonths = function (data) {
        var months = [];
        var month = [];
        data.forEach(function (item, index) {
            month.push(item);
            if (index === data.length - 1 || moment(item.date).month() !== moment(data[index + 1].date).month()) {
                months.push(month);
                month = [];
            }
        });
        return months;
    };
    ChartDateIntervalSelectorMapperService.prototype.getMonthsAverage = function (data) {
        var _this = this;
        return data.map(function (month) {
            var filteredMonth = month.filter(function (item) { return item.totalCount !== 0; });
            var sum = filteredMonth.reduce(function (acc, curr) { return acc + curr.value; }, 0);
            var totalCount = month.reduce(function (acc, curr) { return acc + curr.totalCount; }, 0);
            var average = sum / (filteredMonth.length || 1);
            return {
                name: "" + _this.capitalize(moment(month[0].date).format('MMMM')),
                formattedName: "" + _this.capitalize(moment(month[0].date).format('MMMM')),
                initialDate: month[0].date,
                finalDate: month[month.length - 1].date,
                value: average,
                totalCount: totalCount
            };
        });
    };
    ChartDateIntervalSelectorMapperService.prototype.capitalize = function (s) {
        if (typeof s !== 'string') {
            return '';
        }
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    };
    ChartDateIntervalSelectorMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ChartDateIntervalSelectorMapperService_Factory() { return new ChartDateIntervalSelectorMapperService(i0.ɵɵinject(i1.TranslateService)); }, token: ChartDateIntervalSelectorMapperService, providedIn: "root" });
    return ChartDateIntervalSelectorMapperService;
}());
export { ChartDateIntervalSelectorMapperService };
